import { render } from "./DetailPanel.component.html?vue&type=template&id=7dfa16a5&scoped=true&ts=true&external"
import script from "./DetailPanel.component.ts?vue&type=script&lang=ts&external"
export * from "./DetailPanel.component.ts?vue&type=script&lang=ts&external"

import "./DetailPanel.component.scss?vue&type=style&index=0&id=7dfa16a5&scoped=true&lang=scss&external"
import "./ClassificationIndicatorList.component.scss?vue&type=style&index=1&id=7dfa16a5&scoped=true&lang=scss&external"
import "./IndicatorHeadlineShared.scss?vue&type=style&index=2&id=7dfa16a5&scoped=true&lang=scss&external"
import "./Ecl.component.scss?vue&type=style&index=3&id=7dfa16a5&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfa16a5"]])

export default __exports__